export default __webpack_public_path__ + "static/media/bkg--enquire.87fd1611.jpg";